import { customer as customerApi } from '@/api/payment';
import { sleep } from '@/utils';

export default {
  namespaced: true,
  state: {
    paymentMethods: [],
    isPaymentMethodsLoading: false,
    subscriptionPlan: null,
  },
  mutations: {
    startPaymentMethodLoading(state) {
      state.isPaymentMethodsLoading = true;
    },
    stopPaymentMethodLoading(state) {
      state.isPaymentMethodsLoading = false;
    },
    setPaymentMethods(state, paymentMethods = []) {
      state.paymentMethods = paymentMethods;
    },
    setSubscriptionPlan(state, subscriptionPlan) {
      state.subscriptionPlan = subscriptionPlan;
    },
  },
  actions: {
    async payFailedAmount({ dispatch }, props) {
      const { customerId, invoiceId } = props;

      try {
        await customerApi.payInvoice({ customerId, invoiceId });


        await dispatch('loadSubscriptionPlan', customerId);
      } catch (err) {
        // wait a little as webhook needs time to proceed
        await sleep(2000);
        // reload payment methods as they may show users an error message
        await Promise.all([
          dispatch('loadSubscriptionPlan', customerId),
          dispatch('loadPaymentMethods'),
        ]);

        throw err;
      }
    },
    async loadSubscriptionPlan({ commit }, customerId) {
      if (!customerId) {
        return;
      }

      const { data: subscriptionPlan } = await customerApi.getCurrentPlan({ customerId });

      commit('setSubscriptionPlan', subscriptionPlan);
    },
    async loadPaymentMethods({ commit, getters }) {
      try {
        if (!getters.customerId) {
          return;
        }

        commit('startPaymentMethodLoading');
        const { data: paymentMethods } = await customerApi.getPaymentMethods({ customerId: getters.customerId });

        commit('setPaymentMethods', paymentMethods);
      } catch (err) {
        commit('setPaymentMethods', []);
        throw err;
      } finally {
        commit('stopPaymentMethodLoading');
      }
    },
    async setDefaultPaymentMethod({ dispatch }, { customerId, paymentMethodId }) {
      await customerApi.setDefaultPaymentMethod({ customerId, paymentMethodId });
      await dispatch('loadPaymentMethods');
    },
  },
  getters: {
    customerId: (state, getters, rootState, rootGetters) => rootGetters['user/customerId'],
    paymentMethods: state => state.paymentMethods || [],
    isPaymentMethodsLoading: state => state.isPaymentMethodsLoading,
    subscriptionPlan: state => state.subscriptionPlan,
    localeCurrency: (state, getters, rootState, rootGetters) => rootGetters['user/user'].localeCurrency || 'usd',
  },
};
